module.exports = {
    BROKER_GET_MY_INVESTMENTS_FAILURE: 'BROKER_GET_MY_INVESTMENTS_FAILURE',
    BROKER_GET_MY_INVESTMENTS_REQUEST: 'BROKER_GET_MY_INVESTMENTS_REQUEST',
    BROKER_GET_MY_INVESTMENTS_SUCCESS: 'BROKER_GET_MY_INVESTMENTS_SUCCESS',
    RA_ADDITIONAL_CONTRIBUTION_FAILURE: 'RA_ADDITIONAL_CONTRIBUTION_FAILURE',
    RA_ADDITIONAL_CONTRIBUTION_IN_PROGRESS:
        'RA_ADDITIONAL_CONTRIBUTION_IN_PROGRESS',
    RA_ADDITIONAL_CONTRIBUTION_RECURRING_TRANSFER_VALIDATION_SUCCESS:
        'RA_ADDITIONAL_CONTRIBUTION_RECURRING_TRANSFER_VALIDATION_SUCCESS',
    RA_ADDITIONAL_CONTRIBUTION_RESET_PORTFOLIO:
        'RA_ADDITIONAL_CONTRIBUTION_RESET_PORTFOLIO',
    RA_ADDITIONAL_CONTRIBUTION_RESET_STEP:
        'RA_ADDITIONAL_CONTRIBUTION_RESET_STEP',
    RA_ADDITIONAL_CONTRIBUTION_RESET: 'RA_ADDITIONAL_CONTRIBUTION_RESET',
    RA_ADDITIONAL_CONTRIBUTION_SET_ACCOUNT:
        'RA_ADDITIONAL_CONTRIBUTION_SET_ACCOUNT',
    RA_ADDITIONAL_CONTRIBUTION_SET_CONTRIBUTION_AMOUNT:
        'RA_ADDITIONAL_CONTRIBUTION_SET_CONTRIBUTION_AMOUNT',
    RA_ADDITIONAL_CONTRIBUTION_SET_CONTRIBUTION_DAY:
        'RA_ADDITIONAL_CONTRIBUTION_SET_CONTRIBUTION_DAY',
    RA_ADDITIONAL_CONTRIBUTION_SET_PERIODICITY:
        'RA_ADDITIONAL_CONTRIBUTION_SET_PERIODICITY',
    RA_ADDITIONAL_CONTRIBUTION_SET_PORTFOLIO:
        'RA_ADDITIONAL_CONTRIBUTION_SET_PORTFOLIO',
    RA_ADDITIONAL_CONTRIBUTION_SET_RECURRING_CONTRIBUTION_AMOUNT:
        'RA_ADDITIONAL_CONTRIBUTION_SET_RECURRING_CONTRIBUTION_AMOUNT',
    RA_ADDITIONAL_CONTRIBUTION_SET_VISIBLE_STEP:
        'RA_ADDITIONAL_CONTRIBUTION_SET_VISIBLE_STEP',
    RA_ADDITIONAL_CONTRIBUTION_SUCCESS: 'RA_ADDITIONAL_CONTRIBUTION_SUCCESS',
    RA_ADDITIONAL_CONTRIBUTION_VALIDATE_FORM:
        'RA_ADDITIONAL_CONTRIBUTION_VALIDATE_FORM',
    RA_ADDITIONAL_CONTRIBUTION_VALIDATE_UI_STEP:
        'RA_ADDITIONAL_CONTRIBUTION_VALIDATE_UI_STEP',
    RA_ADDITIONAL_CONTRIBUTION_VALIDATION_MONEY_FAILURE:
        'RA_ADDITIONAL_CONTRIBUTION_VALIDATION_MONEY_FAILURE',
    RA_ADDITIONAL_CONTRIBUTION_GET_PDF_FETCHING:
        'RA_ADDITIONAL_CONTRIBUTION_GET_PDF_FETCHING',
    RA_ADDITIONAL_CONTRIBUTION_GET_PDF_SUCCESS:
        'RA_ADDITIONAL_CONTRIBUTION_GET_PDF_SUCCESS',
    RA_ADDITIONAL_CONTRIBUTION_GET_PDF_FAILURE:
        'RA_ADDITIONAL_CONTRIBUTION_GET_PDF_FAILURE',

    RA_ALERTS_FAILURE: 'RA_ALERTS_FAILURE',
    RA_ALERTS_REQUEST: 'RA_ALERTS_REQUEST',
    RA_ALERTS_SUCCESS: 'RA_ALERTS_SUCCESS',

    RA_ASSOCIATE_OBJECTIVE_FAILURE: 'RA_ASSOCIATE_OBJECTIVE_FAILURE',
    RA_ASSOCIATE_OBJECTIVE_REQUEST: 'RA_ASSOCIATE_OBJECTIVE_REQUEST',
    RA_ASSOCIATE_OBJECTIVE_SUCCESS: 'RA_ASSOCIATE_OBJECTIVE_SUCCESS',
    RA_ASSOCIATE_OBJECTIVE_SET_ACCOUNT: 'RA_ASSOCIATE_OBJECTIVE_SET_ACCOUNT',
    RA_ASSOCIATE_OBJECTIVE_SET_VALUES: 'RA_ASSOCIATE_OBJECTIVE_SET_VALUES',
    RA_ASSOCIATE_OBJECTIVE_RESET: 'RA_ASSOCIATE_OBJECTIVE_RESET',
    RA_ASSOCIATE_OBJECTIVE_GET_SIGNATURE_PATTERN:
        'RA_ASSOCIATE_OBJECTIVE_GET_SIGNATURE_PATTERN',
    RA_ASSOCIATE_OBJECTIVE_SET_MAX_TYPE_OF_PRODUCT:
        'RA_ASSOCIATE_OBJECTIVE_SET_MAX_TYPE_OF_PRODUCT',
    RA_ASSOCIATE_OBJECTIVE_TRANSFER_VALIDATION_SUCCESS:
        'RA_ASSOCIATE_OBJECTIVE_TRANSFER_VALIDATION_SUCCESS',

    RA_CANCEL_PERIODIC_CONTRIBUTIONS_FAILURE:
        'RA_CANCEL_PERIODIC_CONTRIBUTIONS_FAILURE',
    RA_CANCEL_PERIODIC_CONTRIBUTIONS_REQUEST:
        'RA_CANCEL_PERIODIC_CONTRIBUTIONS_REQUEST',
    RA_CANCEL_PERIODIC_CONTRIBUTIONS_SUCCESS:
        'RA_CANCEL_PERIODIC_CONTRIBUTIONS_SUCCESS',
    RA_CANCEL_PERIODIC_CONTRIBUTIONS_FINISH:
        'RA_CANCEL_PERIODIC_CONTRIBUTIONS_FINISH',
    RA_CANCEL_PERIODIC_CONTRIBUTIONS_RESET:
        'RA_CANCEL_PERIODIC_CONTRIBUTIONS_RESET',
    RA_CANCEL_PERIODIC_CONTRIBUTIONS_SET_VISIBLE_STEP:
        'RA_CANCEL_PERIODIC_CONTRIBUTIONS_SET_VISIBLE_STEP',
    RA_CANCEL_PLAN_FAILURE: 'RA_CANCEL_PLAN_FAILURE',
    RA_CANCEL_PLAN_FINISH: 'RA_CANCEL_PLAN_FINISH',
    RA_CANCEL_PLAN_IN_PROGRESS: 'RA_CANCEL_PLAN_IN_PROGRESS',
    RA_CANCEL_PLAN_RESET: 'RA_CANCEL_PLAN_RESET',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SCHEME_CONTRIBUTION_RESET:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_SCHEME_CONTRIBUTION_RESET',
    RA_CANCEL_PLAN_SUCCESS: 'RA_CANCEL_PLAN_SUCCESS',
    RA_CHECK_STATUS_FAILURE: 'RA_CHECK_STATUS_FAILURE',
    RA_CHECK_STATUS_REQUEST: 'RA_CHECK_STATUS_REQUEST',
    RA_CHECK_STATUS_SUCCESS: 'RA_CHECK_STATUS_SUCCESS',
    RA_CHECK_LANDING_REDIRECT: 'RA_CHECK_LANDING_REDIRECT',
    RA_CONTINUE_WITH_UNSUCCESS_TEST: 'RA_CONTINUE_WITH_UNSUCCESS_TEST',
    RA_CURRENT_PROJECTION_CHART_FAILURE: 'RA_CURRENT_PROJECTION_CHART_FAILURE',
    RA_CURRENT_PROJECTION_CHART_REQUEST: 'RA_CURRENT_PROJECTION_CHART_REQUEST',
    RA_CURRENT_PROJECTION_CHART_SUCCESS: 'RA_CURRENT_PROJECTION_CHART_SUCCESS',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_DATA_FROM_SIMULATION:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_DATA_FROM_SIMULATION',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_END_DATE_ERROR_ENABLED:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_END_DATE_ERROR_ENABLED',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_RESET: 'RA_CUSTOM_PLAN_BY_OBJECTIVE_RESET',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_CONTRIBUTION_DAY:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_CONTRIBUTION_DAY',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_INITIAL_CONTRIBUTION_AMOUNT:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_INITIAL_CONTRIBUTION_AMOUNT',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_AMOUNT:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_AMOUNT',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_END_DATE:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_END_DATE',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_PERIODICITY:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_PERIODICITY',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_RECURRING_CONTRIBUTION_AMOUNT:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_RECURRING_CONTRIBUTION_AMOUNT',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_SELECTED_STRATEGY:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_SELECTED_STRATEGY',
    RA_CUSTOM_PLAN_BY_OBJECTIVE_UPDATE_DESCRIPTION:
        'RA_CUSTOM_PLAN_BY_OBJECTIVE_UPDATE_DESCRIPTION',
    RA_DISSOCIATE_OBJECTIVE_FAILURE: 'RA_DISSOCIATE_OBJECTIVE_FAILURE',
    RA_DISSOCIATE_OBJECTIVE_REQUEST: 'RA_DISSOCIATE_OBJECTIVE_REQUEST',
    RA_DISSOCIATE_OBJECTIVE_SUCCESS: 'RA_DISSOCIATE_OBJECTIVE_SUCCESS',
    RA_DISSOCIATE_OBJECTIVE_RESET: 'RA_DISSOCIATE_OBJECTIVE_RESET',
    RA_EXPECTED_PROFITABILITY_CHANGE_YEARS:
        'RA_EXPECTED_PROFITABILITY_CHANGE_YEARS',
    RA_EXPECTED_PROFITABILITY_CHART_FAILURE:
        'RA_EXPECTED_PROFITABILITY_CHART_FAILURE',
    RA_EXPECTED_PROFITABILITY_CHART_REQUEST:
        'RA_EXPECTED_PROFITABILITY_CHART_REQUEST',
    RA_EXPECTED_PROFITABILITY_CHART_SUCCESS:
        'RA_EXPECTED_PROFITABILITY_CHART_SUCCESS',
    RA_EXPECTED_PROFITABILITY_SET_DAYS_DIFF:
        'RA_EXPECTED_PROFITABILITY_SET_DAYS_DIFF',
    RA_EXPECTED_PROFITABILITY_RESET: 'RA_EXPECTED_PROFITABILITY_RESET',
    RA_FEATURE_FLAG_FAILURE: 'RA_FEATURE_FLAG_FAILURE',
    RA_FEATURE_FLAG_MODAL_TOGGLE: 'RA_FEATURE_FLAG_MODAL_TOGGLE',
    RA_FEATURE_FLAG_REQUEST: 'RA_FEATURE_FLAG_REQUEST',
    RA_FEATURE_FLAG_SUCCESS: 'RA_FEATURE_FLAG_SUCCESS',
    RA_GET_ACCOUNT_DETAILS_REQUEST: 'RA_GET_ACCOUNT_DETAILS_REQUEST',
    RA_GET_ACCOUNT_DETAILS_SUCCESS: 'RA_GET_ACCOUNT_DETAILS_SUCCESS',
    RA_GET_ACCOUNT_DETAILS_FAILURE: 'RA_GET_ACCOUNT_DETAILS_FAILURE',
    RA_PORTFOLIO_HISTORY_REQUEST: 'RA_PORTFOLIO_HISTORY_REQUEST',
    RA_SUITABILITY_TEST_GET_PDF_TEST_FETCHING:
        'RA_SUITABILITY_TEST_GET_PDF_TEST_FETCHING',
    RA_PORTFOLIO_HISTORY_REQUEST_SUCCESS:
        'RA_PORTFOLIO_HISTORY_REQUEST_SUCCESS',
    RA_SUITABILITY_TEST_GET_PDF_TEST_FAILURE:
        'RA_SUITABILITY_TEST_GET_PDF_TEST_FAILURE',
    RA_PORTFOLIO_HISTORY_REQUEST_FAILURE:
        'RA_PORTFOLIO_HISTORY_REQUEST_FAILURE',
    RA_SUITABILITY_HANDLE_CLOSE_MODAL_INVESTMENT_EXPERIENCE:
        'RA_SUITABILITY_HANDLE_CLOSE_MODAL_INVESTMENT_EXPERIENCE',
    RA_SUITABILITY_GET_INVESTMENT_EXPERIENCE_SUCCESS:
        'RA_SUITABILITY_GET_INVESTMENT_EXPERIENCE_SUCCESS',
    RA_GET_INVESTMENT_TERM_SLIDER: 'RA_GET_INVESTMENT_TERM_SLIDER',
    RA_GET_LAST_MOVEMENT_FAILURE: 'RA_GET_LAST_MOVEMENT_FAILURE',
    RA_GET_LAST_MOVEMENT_REQUEST: 'RA_GET_LAST_MOVEMENT_REQUEST',
    RA_GET_LAST_MOVEMENT_SUCCESS: 'RA_GET_LAST_MOVEMENT_SUCCESS',
    RA_GET_LAST_MOVEMENT_SET_FILTER: 'RA_GET_LAST_MOVEMENT_SET_FILTER',
    RA_LAST_MOVEMENT_CLAER_FILTER: 'RA_GET_LAST_MOVEMENT_CLAER_FILTER',
    RA_GLOBAL_POSITION_DISABLED_NOTIFICATION_FAILED:
        'RA_GLOBAL_POSITION_DISABLED_NOTIFICATION_FAILED',
    RA_GLOBAL_POSITION_DISABLED_NOTIFICATION_SUCCESS:
        'RA_GLOBAL_POSITION_DISABLED_NOTIFICATION_SUCCESS',
    RA_GLOBAL_POSITION_SET_ORIGIN_REDIRECTION:
        'RA_GLOBAL_POSITION_SET_ORIGIN_REDIRECTION',
    RA_GLOBAL_POSITION_SET_SELECTED_PORTFOLIO:
        'RA_GLOBAL_POSITION_SET_SELECTED_PORTFOLIO',
    RA_GLOBAL_POSITION_GET_SAVE_SIMULATION_MESSAGE:
        'RA_GLOBAL_POSITION_GET_SAVE_SIMULATION_MESSAGE',
    RA_GLOBAL_POSITION_SET_ROBO_TRANSFER_NOTIFICATION_CLOSED:
        'RA_GLOBAL_POSITION_SET_ROBO_TRANSFER_NOTIFICATION_CLOSED',
    RA_HIRE_MANAGEMENT_EXPLICIT_IMPLICIT_COST_ERROR:
        'RA_HIRE_MANAGEMENT_EXPLICIT_IMPLICIT_COST_ERROR',
    RA_HIRE_MANAGEMENT_EXPLICIT_IMPLICIT_COST_RETRIEVED:
        'RA_HIRE_MANAGEMENT_EXPLICIT_IMPLICIT_COST_RETRIEVED',
    RA_HIRE_MANAGEMENT_PLAN_CHANGE_TRANSFER_FUNDS_ACCOUNT:
        'RA_HIRE_MANAGEMENT_PLAN_CHANGE_TRANSFER_FUNDS_ACCOUNT',
    RA_HIRE_MANAGEMENT_PLAN_CHANGE_INVESTMENT_TYPE:
        'RA_HIRE_MANAGEMENT_PLAN_CHANGE_INVESTMENT_TYPE',
    RA_HIRE_MANAGEMENT_PLAN_CONFIGURE_EMAIL:
        'RA_HIRE_MANAGEMENT_PLAN_CONFIGURE_EMAIL',
    RA_HIRE_MANAGEMENT_PLAN_CLOSE_DISTRIBUTION_MODAL:
        'RA_HIRE_MANAGEMENT_PLAN_CLOSE_DISTRIBUTION_MODAL',
    RA_HIRE_MANAGEMENT_PLAN_CREATE_ACCOUNT_ERROR:
        'RA_HIRE_MANAGEMENT_PLAN_CREATE_ACCOUNT_ERROR',
    RA_HIRE_MANAGEMENT_PLAN_CREATE_ACCOUNT_REQUEST:
        'RA_HIRE_MANAGEMENT_PLAN_CREATE_ACCOUNT_REQUEST',
    RA_HIRE_MANAGEMENT_PLAN_EMAIL_CONFIG_ERROR:
        'RA_HIRE_MANAGEMENT_PLAN_EMAIL_CONFIG_ERROR',
    RA_HIRE_MANAGEMENT_PLAN_ENABLE_DISCLAIMER_CHECK:
        'RA_HIRE_MANAGEMENT_PLAN_ENABLE_DISCLAIMER_CHECK',
    RA_HIRE_MANAGEMENT_PLAN_FINISH: 'RA_HIRE_MANAGEMENT_PLAN_FINISH',
    RA_HIRE_MANAGEMENT_PLAN_INVESTMENT_AMOUNT_CHANGED:
        'RA_HIRE_MANAGEMENT_PLAN_INVESTMENT_AMOUNT_CHANGED',
    RA_HIRE_MANAGEMENT_PLAN_DMS_INIT_FETCHING:
        'RA_HIRE_MANAGEMENT_PLAN_DMS_INIT_FETCHING',
    RA_HIRE_MANAGEMENT_PLAN_DMS_INIT_SUCCESS:
        'RA_HIRE_MANAGEMENT_PLAN_DMS_INIT_SUCCESS',
    RA_HIRE_MANAGEMENT_PLAN_DMS_INIT_ERROR:
        'RA_HIRE_MANAGEMENT_PLAN_DMS_INIT_ERROR',
    RA_HIRE_MANAGEMENT_PLAN_OPEN_DISTRIBUTION_MODAL:
        'RA_HIRE_MANAGEMENT_PLAN_OPEN_DISTRIBUTION_MODAL',
    RA_HIRE_MANAGEMENT_PLAN_RESET_STEP: 'RA_HIRE_MANAGEMENT_PLAN_RESET_STEP',
    RA_HIRE_MANAGEMENT_PLAN_RESET: 'RA_HIRE_MANAGEMENT_PLAN_RESET',
    RA_HIRE_MANAGEMENT_PLAN_SAVE_TERMS_AND_CONDITIONS:
        'RA_HIRE_MANAGEMENT_PLAN_SAVE_TERMS_AND_CONDITIONS',
    RA_HIRE_MANAGEMENT_PLAN_SELECTED_ACCOUNT_CHANGED:
        'RA_HIRE_MANAGEMENT_PLAN_SELECTED_ACCOUNT_CHANGED',
    RA_HIRE_MANAGEMENT_PLAN_SET_CONTRIBUTIONDAY:
        'RA_HIRE_MANAGEMENT_PLAN_SET_CONTRIBUTIONDAY',
    RA_HIRE_MANAGEMENT_PLAN_SET_PDF: 'RA_HIRE_MANAGEMENT_PLAN_SET_PDF',
    RA_HIRE_MANAGEMENT_PLAN_SET_CONCAT_PDF:
        'RA_HIRE_MANAGEMENT_PLAN_SET_CONCAT_PDF',
    RA_HIRE_MANAGEMENT_PLAN_SET_PERIODICITY:
        'RA_HIRE_MANAGEMENT_PLAN_SET_PERIODICITY',
    RA_HIRE_MANAGEMENT_PLAN_SET_RECURRING_CONTRIBUTION_AMOUNT:
        'RA_HIRE_MANAGEMENT_PLAN_SET_RECURRING_CONTRIBUTION_AMOUNT',
    RA_HIRE_MANAGEMENT_PLAN_SET_VISIBLE_STEP:
        'RA_HIRE_MANAGEMENT_PLAN_VISIBLE_STEP',
    RA_HIRE_MANAGEMENT_PLAN_TOGGLE_DISCLAIMER:
        'RA_HIRE_MANAGEMENT_PLAN_TOGGLE_DISCLAIMER',
    RA_HIRE_MANAGEMENT_PLAN_UPDATE_ENABLED_ACCOUNTS:
        'RA_HIRE_MANAGEMENT_PLAN_UPDATE_ENABLED_ACCOUNTS',
    RA_HIRE_MANAGEMENT_PLAN_UPDATE_SELECTED_ACCOUNTS_WITH_FUNDS:
        'RA_HIRE_MANAGEMENT_PLAN_UPDATE_SELECTED_ACCOUNTS_WITH_FUNDS',
    RA_HIRE_MANAGEMENT_PLAN_UPDATE_SELECTED_FUNDS_TOTAL:
        'RA_HIRE_MANAGEMENT_PLAN_UPDATE_SELECTED_FUNDS_TOTAL',
    RA_HIRE_MANAGEMENT_PLAN_VALIDATE_UI_STEP:
        'RA_HIRE_MANAGEMENT_PLAN_VALIDATE_UI_STEP',
    RA_HIRE_MANAGEMENT_PLAN_SET_EMAIL_CONFIG_FLAG:
        'RA_HIRE_MANAGEMENT_PLAN_SET_EMAIL_CONFIG_FLAG',
    RA_HIRE_MANAGEMENT_CONFIRM_GET_PDF_FETCHING:
        'RA_HIRE_MANAGEMENT_CONFIRM_GET_PDF_FETCHING',
    RA_HIRE_MANAGEMENT_CONFIRM_GET_PDF_SUCCESS:
        'RA_HIRE_MANAGEMENT_CONFIRM_GET_PDF_SUCCESS',
    RA_HIRE_MANAGEMENT_CONFIRM_GET_PDF_FAILURE:
        'RA_HIRE_MANAGEMENT_CONFIRM_GET_PDF_FAILURE',
    RA_LAST_MOVEMENT_CHANGE_FILTER: 'RA_LAST_MOVEMENT_CHANGE_FILTER',
    RA_LAST_MOVEMENT_CHANGE_TEMPORAL_FILTER:
        'RA_LAST_MOVEMENT_CHANGE_TEMPORAL_FILTER',
    RA_LAST_MOVEMENT_SET_FILTER_LABEL: 'RA_LAST_MOVEMENT_SET_FILTER_LABEL',
    RA_LAST_MOVEMENT_UPDATE_FILTER: 'RA_LAST_MOVEMENT_UPDATE_FILTER',
    RA_MANAGEMENT_PLAN_CHANGE_PRODUCT_ERROR:
        'RA_MANAGEMENT_CHANGE_PRODUCT_ERROR',
    RA_MANAGEMENT_PLAN_CHANGE_PRODUCT_REQUEST:
        'RA_MANAGEMENT_CHANGE_PRODUCT_REQUEST',
    RA_MANAGEMENT_PLAN_CHANGE_PRODUCT_SUCCESS:
        'RA_MANAGEMENT_CHANGE_PRODUCT_SUCCESS',
    RA_MANAGEMENT_PLAN_FETCHING_VALIDATE_BLOCKED_ACCOUNTS:
        'RA_MANAGEMENT_PLAN_FETCHING_VALIDATE_BLOCKED_ACCOUNTS',
    RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_FAILURE:
        'RA_MANAGEMENT_GET_INVESTMENT_PROFILE_FAILURE',
    RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_REQUEST:
        'RA_MANAGEMENT_GET_INVESTMENT_PROFILE_REQUEST',
    RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_SUCCESS:
        'RA_MANAGEMENT_GET_INVESTMENT_PROFILE_SUCCESS',
    RA_MANAGEMENT_PLAN_INCLUDE_GOAL: 'RA_MANAGEMENT_PLAN_INCLUDE_GOAL',
    RA_MANAGEMENT_PLAN_MODIFY_PROFILE: 'RA_MANAGEMENT_PLAN_MODIFY_PROFILE',
    RA_MANAGEMENT_PLAN_MODIFY_STRATEGY: 'RA_MANAGEMENT_PLAN_MODIFY_STRATEGY',
    RA_MANAGEMENT_PLAN_MODIFY_STRATEGY_AND_PROFILE:
        'RA_MANAGEMENT_PLAN_MODIFY_STRATEGY_AND_PROFILE',
    RA_MANAGEMENT_PLAN_RESET: 'RA_MANAGEMENT_PLAN_RESET',
    RA_MANAGEMENT_PLAN_SAVE_SIMULATION_FAILURE:
        'RA_MANAGEMENT_SAVE_SIMULATION_FAILURE',
    RA_MANAGEMENT_PLAN_SAVE_SIMULATION_REQUEST:
        'RA_MANAGEMENT_SAVE_SIMULATION_REQUEST',
    RA_MANAGEMENT_PLAN_SAVE_SIMULATION_SUCCESS:
        'RA_MANAGEMENT_SAVE_SIMULATION_SUCCESS',
    RA_MANAGEMENT_PLAN_SELECT_STRATEGY: 'RA_MANAGEMENT_PLAN_SELECT_STRATEGY',
    RA_MANAGEMENT_PLAN_SET_CONTRIBUTION_DAY:
        'RA_MANAGEMENT_PLAN_SET_CONTRIBUTION_DAY',
    RA_MANAGEMENT_PLAN_SET_CUSTOM_NAME: 'RA_MANAGEMENT_PLAN_SET_CUSTOM_NAME',
    RA_MANAGEMENT_PLAN_SET_EDIT_CLICKED: 'RA_MANAGEMENT_PLAN_SET_EDIT_CLICKED',
    RA_MANAGEMENT_PLAN_SET_INITIAL_CONTRIBUTION_AMOUNT:
        'RA_MANAGEMENT_PLAN_SET_INITIAL_CONTRIBUTION_AMOUNT',
    RA_MANAGEMENT_PLAN_SET_PERIODICITY: 'RA_MANAGEMENT_PLAN_SET_PERIODICITY',
    RA_MANAGEMENT_PLAN_SET_RECURRING_CONTRIBUTION_AMOUNT:
        'RA_MANAGEMENT_PLAN_SET_RECURRING_CONTRIBUTION_AMOUNT',
    RA_MANAGEMENT_PLAN_SHOW_DETAILS: 'RA_MANAGEMENT_PLAN_SHOW_DETAILS',
    RA_MANAGEMENT_PLAN_UPDATE_CUSTOM_NAME:
        'RA_MANAGEMENT_PLAN_UPDATE_CUSTOM_NAME',
    RA_MANAGEMENT_PLAN_UPDATE_INVEST_SLIDER:
        'RA_MANAGEMENT_PLAN_UPDATE_INVEST_SLIDER',
    RA_NONRESIDENTIAL_MODAL_CLOSE: 'RA_NONRESIDENTIAL_MODAL_CLOSE',
    RA_NONRESIDENTIAL_MODAL_VALIDATION: 'RA_NONRESIDENTIAL_MODAL_VALIDATION',
    RA_OBJ_TRACKING_EVOLUTION_CHANGE_OPTION:
        'RA_OBJ_TRACKING_EVOLUTION_CHANGE_OPTION',
    RA_OBJ_TRACKING_EVOLUTION_FAILURE: 'RA_OBJ_TRACKING_EVOLUTION_FAILURE',
    RA_OBJ_TRACKING_EVOLUTION_REQUEST: 'RA_OBJ_TRACKING_EVOLUTION_REQUEST',
    RA_OBJ_TRACKING_EVOLUTION_SUCCESS: 'RA_OBJ_TRACKING_EVOLUTION_SUCCESS',
    RA_OBJ_TRACKING_PROJECTION_CHART_FAILURE:
        'RA_OBJ_TRACKING_PROJECTION_CHART_FAILURE',
    RA_OBJ_TRACKING_PROJECTION_CHART_REQUEST:
        'RA_OBJ_TRACKING_PROJECTION_CHART_REQUEST',
    RA_OBJ_TRACKING_PROJECTION_CHART_SET_DAYS_DIFF:
        'RA_OBJ_TRACKING_PROJECTION_CHART_SET_DAYS_DIFF',
    RA_OBJ_TRACKING_PROJECTION_CHART_SUCCESS:
        'RA_OBJ_TRACKING_PROJECTION_CHART_SUCCESS',
    RA_OBJECTIVE_DETAILS_HEADER_TITLE_ERROR_ENABLED:
        'RA_OBJECTIVE_DETAILS_HEADER_TITLE_ERROR_ENABLED',
    RA_OBJECTIVE_DETAILS_FAILURE: 'RA_OBJECTIVE_DETAILS_FAILURE',
    RA_OBJECTIVE_DETAILS_RESET: 'RA_OBJECTIVE_DETAILS_RESET',
    RA_OBJECTIVE_DETAILS_SET_FROM_PG_NOTIFICATION:
        'RA_OBJECTIVE_DETAILS_SET_FROM_PG_NOTIFICATION',
    RA_OBJECTIVE_DETAILS_SET_PORTFOLIO_DATA:
        'RA_OBJECTIVE_DETAILS_SET_PORTFOLIO_DATA',
    RA_OBJECTIVE_EDIT_AMOUNT_MODAL_HIDE: 'RA_OBJECTIVE_EDIT_AMOUNT_MODAL_HIDE',
    RA_OBJECTIVE_EDIT_AMOUNT_MODAL_SHOW: 'RA_OBJECTIVE_EDIT_AMOUNT_MODAL_SHOW',
    RA_OBJECTIVE_NAME_UPDATE_FAILURE: 'RA_OBJECTIVE_NAME_UPDATE_FAILURE',
    RA_OBJECTIVE_NAME_UPDATE_REQUEST: 'RA_OBJECTIVE_NAME_UPDATE_REQUEST',
    RA_OBJECTIVE_NAME_UPDATE_SUCCESS: 'RA_OBJECTIVE_NAME_UPDATE_SUCCESS',
    RA_OBJECTIVE_RESET_AMOUNT_VALUE: 'RA_OBJECTIVE_RESET_AMOUNT_VALUE',
    RA_PORTFOLIO_DETAILS_HEADER_TITLE_ERROR_ENABLED:
        'RA_PORTFOLIO_DETAILS_HEADER_TITLE_ERROR_ENABLED',
    RA_PORTFOLIO_DETAILS_FAILURE: 'RA_PORTFOLIO_DETAILS_FAILURE',
    RA_PORTFOLIO_DETAILS_REQUEST: 'RA_PORTFOLIO_DETAILS_REQUEST',
    RA_PORTFOLIO_DETAILS_SUCCESS: 'RA_PORTFOLIO_DETAILS_SUCCESS',
    RA_PORTFOLIO_DETAILS_RESET: 'RA_PORTFOLIO_DETAILS_RESET',
    RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_DATA:
        'RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_DATA',
    RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_IN_PROGRESS:
        'RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_IN_PROGRESS',
    RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_SUCCESS:
        'RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_SUCCESS',
    RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_FAILURE:
        'RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_FAILURE',
    RA_PORTFOLIO_DISTRIBUTION_CANCEL_MODIFY_PLAN_MODAL:
        'RA_PORTFOLIO_DISTRIBUTION_CANCEL_MODIFY_PLAN_MODAL',
    RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_FAILURE:
        'RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_FAILURE',
    RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_REQUEST:
        'RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_REQUEST',
    RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_SUCCESS:
        'RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_SUCCESS',
    RA_PORTFOLIO_DISTRIBUTION_RESET_COMPARATIVE:
        'RA_PORTFOLIO_DISTRIBUTION_RESET_COMPARATIVE',
    RA_PORTFOLIO_DISTRIBUTION_RESET_PORTFOLIO:
        'RA_PORTFOLIO_DISTRIBUTION_RESET_PORTFOLIO',
    RA_PORTFOLIO_EVOLUTION_CHANGE_MODAL_OPTION:
        'RA_PORTFOLIO_EVOLUTION_CHANGE_MODAL_OPTION',
    RA_PORTFOLIO_EVOLUTION_CHANGE_OPTION:
        'RA_PORTFOLIO_EVOLUTION_CHANGE_OPTION',
    RA_PORTFOLIO_EVOLUTION_FAILURE: 'RA_PORTFOLIO_EVOLUTION_FAILURE',
    RA_PORTFOLIO_EVOLUTION_REQUEST: 'RA_PORTFOLIO_EVOLUTION_REQUEST',
    RA_PORTFOLIO_EVOLUTION_SUCCESS: 'RA_PORTFOLIO_EVOLUTION_SUCCESS',
    RA_PORTFOLIO_EVOLUTION_TOTALS_FAILURE:
        'RA_PORTFOLIO_EVOLUTION_TOTALS_FAILURE',
    RA_PORTFOLIO_EVOLUTION_TOTALS_REQUEST:
        'RA_PORTFOLIO_EVOLUTION_TOTALS_REQUEST',
    RA_PORTFOLIO_EVOLUTION_TOTALS_SUCCESS:
        'RA_PORTFOLIO_EVOLUTION_TOTALS_SUCCESS',
    RA_PORTFOLIOS_NAME_HISTORY_GET_DISPLAY_NAMES_FAILURE:
        'RA_PORTFOLIOS_NAME_HISTORY_GET_DISPLAY_NAMES_FAILURE',
    RA_PORTFOLIOS_NAME_HISTORY_GET_DISPLAY_NAMES_REQUEST:
        'RA_PORTFOLIOS_NAME_HISTORY_GET_DISPLAY_NAMES_REQUEST',
    RA_PORTFOLIOS_NAME_HISTORY_GET_DISPLAY_NAMES_SUCCESS:
        'RA_PORTFOLIOS_NAME_HISTORY_GET_DISPLAY_NAMES_SUCCESS',
    RA_REFUND_REQUEST_FAILURE: 'RA_REFUND_REQUEST_FAILURE',
    RA_REFUND_REQUEST_IN_PROGRESS: 'RA_REFUND_REQUEST_IN_PROGRESS',
    RA_REFUND_REQUEST_RESET: 'RA_REFUND_REQUEST_RESET',
    RA_REFUND_REQUEST_SET_REFUND_AMOUNT: 'RA_REFUND_REQUEST_SET_REFUND_AMOUNT',
    RA_REFUND_REQUEST_SUCCESS: 'RA_REFUND_REQUEST_SUCCESS',
    RA_REFUND_REQUEST_VALIDATE_FORM: 'RA_REFUND_REQUEST_VALIDATE_FORM',
    RA_REIMBURSEMENT_MY_INVESTMENT_REQUEST:
        'RA_REIMBURSEMENT_MY_INVESTMENT_REQUEST',
    RA_REIMBURSEMENT_REQUEST_FAILURE: 'RA_REIMBURSEMENT_REQUEST_FAILURE',
    RA_REIMBURSEMENT_REQUEST_GET_INVESTMENTS_FAILURE:
        'RA_REIMBURSEMENT_REQUEST_GET_INVESTMENTS_FAILURE',
    RA_REIMBURSEMENT_REQUEST_GET_INVESTMENTS_SUCCESS:
        'RA_REIMBURSEMENT_REQUEST_GET_INVESTMENTS_SUCCESS',
    RA_REIMBURSEMENT_REQUEST_IN_PROGRESS:
        'RA_REIMBURSEMENT_REQUEST_IN_PROGRESS',
    RA_REIMBURSEMENT_REQUEST_RESET: 'RA_REIMBURSEMENT_REQUEST_RESET',
    RA_REIMBURSEMENT_REQUEST_SET_REIMBURSEMENT_AMOUNT:
        'RA_REIMBURSEMENT_REQUEST_SET_REIMBURSEMENT_AMOUNT',
    RA_REIMBURSEMENT_REQUEST_SUCCESS: 'RA_REIMBURSEMENT_REQUEST_SUCCESS',
    RA_REIMBURSEMENT_REQUEST_VALIDATE_FORM:
        'RA_REIMBURSEMENT_REQUEST_VALIDATE_FORM',
    RA_REIMBURSEMENT_UPDATE_PRODUCT_ID: 'RA_REIMBURSEMENT_UPDATE_PRODUCT_ID',
    RA_SAVE_SIMULATION_REQUEST_FOR_OBJECTIVE:
        'RA_SAVE_SIMULATION_REQUEST_FOR_OBJECTIVE',
    RA_SAVE_SIMULATION_REQUEST_FOR_PORTFOLIO:
        'RA_SAVE_SIMULATION_REQUEST_FOR_PORTFOLIO',
    RA_SAVE_SIMULATION_REQUEST_SUCCESS_FOR_OBJECTIVE:
        'RA_SAVE_SIMULATION_REQUEST_SUCCESS_FOR_OBJECTIVE',
    RA_SAVE_SIMULATION_REQUEST_SUCCESS_FOR_PORTFOLIO:
        'RA_SAVE_SIMULATION_REQUEST_SUCCESS_FOR_PORTFOLIO',
    RA_SAVE_SIMULATION_REQUEST_FAILURE: 'RA_SAVE_SIMULATION_REQUEST_FAILURE',
    RA_SAVE_SIMULATION_REQUEST_TO_SAVE_DATA_FOR_PORTFOLIO:
        'RA_SAVE_SIMULATION_REQUEST_TO_SAVE_DATA_FOR_PORTFOLIO',
    RA_SAVE_SIMULATION_SUCCESS_TO_SAVE_DATA_FOR_PORTFOLIO:
        'RA_SAVE_SIMULATION_SUCCESS_TO_SAVE_DATA_FOR_PORTFOLIO',
    RA_SAVE_SIMULATION_FAILURE_TO_SAVE_DATA_FOR_OBECTIVE:
        'RA_SAVE_SIMULATION_FAILURE_TO_SAVE_DATA_FOR_OBECTIVE',
    RA_SAVE_SIMULATION_FAILURE_TO_SAVE_DATA_FOR_PORTFOLIO:
        'RA_SAVE_SIMULATION_FAILURE_TO_SAVE_DATA_FOR_PORTFOLIO',
    RA_SAVE_SIMULATION_SUCCESS_TO_SAVE_DATA_FOR_OBJECTIVE:
        'RA_SAVE_SIMULATION_SUCCESS_TO_SAVE_DATA_FOR_OBJECTIVE',
    RA_SAVE_SIMULATION_CHANGE_MODAL_OPTION:
        'RA_SAVE_SIMULATION_CHANGE_MODAL_OPTION',
    RA_SAVE_SIMULATION_DISABLE_SIMULATION_BUTTON:
        'RA_SAVE_SIMULATION_DISABLE_SIMULATION_BUTTON',
    RA_SAVE_SIMULATION_RESET: 'RA_SAVE_SIMULATION_RESET',
    RA_SAVE_SIMULATION_OBJECTIVE_CHANGE_MODAL_OPTION:
        'RA_SAVE_SIMULATION_OBJECTIVE_CHANGE_MODAL_OPTION',
    RA_SAVE_SIMULATION_OBJECTIVE_DISABLE_SIMULATION_BUTTON:
        'RA_SAVE_SIMULATION_OBJECTIVE_DISABLE_SIMULATION_BUTTON',
    RA_SAVE_SIMULATION_OBJECTIVE_VALUE_RESET:
        'RA_SAVE_SIMULATION_OBJECTIVE_VALUE_RESET',
    RA_SET_FROM_SET_GOAL: 'RA_SET_FROM_SET_GOAL',
    RA_SET_GOAL_DATE_ERROR_ENABLED: 'RA_SET_GOAL_DATE_ERROR_ENABLED',
    RA_SET_GOAL_GET_DATA_FROM_SIMULATION:
        'RA_SET_GOAL_GET_DATA_FROM_SIMULATION',
    RA_SET_GOAL_RESET: 'RA_SET_GOAL_RESET',
    RA_SET_GOAL_SET_INVESTMENT_GOAL_VALUE:
        'RA_SET_GOAL_SET_INVESTMENT_GOAL_VALUE',
    RA_SET_GOAL_SET_VISIBLE_STEP: 'RA_SET_GOAL_SET_VISIBLE_STEP',
    RA_SET_GOAL_VALIDATE_UI_STEP: 'RA_SET_GOAL_VALIDATE_UI_STEP',
    RA_SIMULATION_REQUEST_SUCCESS: 'RA_SIMULATION_REQUEST_SUCCESS',
    RA_SIMULATION_REQUEST_FAILURE: 'RA_SIMULATION_REQUEST_FAILURE',
    RA_SIMULATION_REQUEST: 'RA_SIMULATION_REQUEST',
    RA_SIMULATION_RESET_SCROLL_HEIGHT: 'RA_SIMULATION_RESET_SCROLL_HEIGHT',
    RA_SIMULATION_UPDATE_SIMULATION: 'RA_SIMULATION_UPDATE_SIMULATION',
    RA_SUITABILITY_GET_TEST_QUESTIONS_FAILURE:
        'RA_SUITABILITY_GET_TEST_QUESTIONS_FAILURE',
    RA_SUITABILITY_GET_TEST_QUESTIONS_REQUEST:
        'RA_SUITABILITY_GET_TEST_QUESTIONS_REQUEST',
    RA_SUITABILITY_GET_TEST_QUESTIONS_SUCCESS:
        'RA_SUITABILITY_GET_TEST_QUESTIONS_SUCCESS',
    RA_SUITABILITY_GET_TEST_RESULT_FAILURE:
        'RA_SUITABILITY_GET_TEST_RESULT_FAILURE',
    RA_SUITABILITY_GET_TEST_RESULT_REQUEST:
        'RA_SUITABILITY_GET_TEST_RESULT_REQUEST',
    RA_SUITABILITY_GET_TEST_RESULT_SUCCESS:
        'RA_SUITABILITY_GET_TEST_RESULT_SUCCESS',
    RA_SIMULATION_SET_SCROLL_HEIGHT: 'RA_SIMULATION_SET_SCROLL_HEIGHT',
    RA_SUITABILITY_TEST_COMPLETED: 'RA_SUITABILITY_TEST_COMPLETED',
    RA_SUITABILITY_TEST_ANSWERED_QUESTION_ZERO:
        'RA_SUITABILITY_TEST_ANSWERED_QUESTION_ZERO',
    RA_SUITABILITY_TEST_EXPAND_ACCORDION_ROW:
        'RA_SUITABILITY_TEST_EXPAND_ACCORDION_ROW',
    RA_SUITABILITY_TEST_HISTORICAL_TEST_REQUEST:
        'RA_SUITABILITY_TEST_HISTORICAL_TEST_REQUEST',
    RA_SUITABILITY_TEST_HISTORICAL_TEST_SUCCESS:
        'RA_SUITABILITY_TEST_HISTORICAL_TEST_SUCCESS',
    RA_SUITABILITY_TEST_DMS_INIT_FETCHING:
        'RA_SUITABILITY_TEST_DMS_INIT_FETCHING',
    RA_SUITABILITY_TEST_DMS_INIT_SUCCESS:
        'RA_SUITABILITY_TEST_DMS_INIT_SUCCESS',
    RA_SUITABILITY_TEST_DMS_INIT_ERROR: 'RA_SUITABILITY_TEST_DMS_INIT_ERROR',
    RA_SUITABILITY_TEST_RESET_ANSWERS: 'RA_SUITABILITY_TEST_RESET_ANSWERS',
    RA_SUITABILITY_TEST_RESET_COHERENCE_ERROR:
        'RA_SUITABILITY_TEST_RESET_COHERENCE_ERROR',
    RA_SUITABILITY_TEST_RESET_TEST_COMPLETED:
        'RA_SUITABILITY_TEST_RESET_TEST_COMPLETED',
    RA_SUITABILITY_TEST_RESET: 'RA_SUITABILITY_TEST_RESET',
    RA_SUITABILITY_TEST_RETRY_REASON_CHANGED:
        'RA_SUITABILITY_TEST_RETRY_REASON_CHANGED',
    RA_SUITABILITY_TEST_REVIEW_IN_PROGRESS:
        'RA_SUITABILITY_TEST_REVIEW_IN_PROGRESS',
    RA_SUITABILITY_TEST_SELECT_ACCORDION_BUTTON:
        'RA_SUITABILITY_TEST_SELECT_ACCORDION_BUTTON',
    RA_SUITABILITY_TEST_SELECT_CHECKBOX_OPTION:
        'RA_SUITABILITY_TEST_SELECT_CHECKBOX_OPTION',
    RA_SUITABILITY_TEST_SEND_TEST_FAILURE:
        'RA_SUITABILITY_TEST_SEND_TEST_FAILURE',
    RA_SUITABILITY_TEST_SEND_TEST_IN_PROGRESS:
        'RA_SUITABILITY_TEST_SEND_TEST_IN_PROGRESS',
    RA_SUITABILITY_TEST_SEND_TEST_SUCCESS:
        'RA_SUITABILITY_TEST_SEND_TEST_SUCCESS',
    RA_SUITABILITY_TEST_SET_COHERENCE_ERROR:
        'RA_SUITABILITY_TEST_SET_COHERENCE_ERROR',
    RA_SUITABILITY_TEST_SET_ORIGIN: 'RA_SUITABILITY_TEST_SET_ORIGIN',
    RA_SUITABILITY_TEST_SET_READ_ONLY: 'RA_SUITABILITY_TEST_SET_READ_ONLY',
    RA_SUITABILITY_TEST_SHOW_MODAL_NEW_QUESTIONS:
        'RA_SUITABILITY_TEST_SHOW_MODAL_NEW_QUESTIONS',
    RA_SUITABILITY_TEST_REMOVE_QUESTION:
        'RA_SUITABILITY_TEST_REMOVE_QUESTION_400',
    RA_SUITABILITY_TEST_SIGN_TEST_FAILURE:
        'RA_SUITABILITY_TEST_SIGN_TEST_FAILURE',
    RA_SUITABILITY_TEST_SIGN_TEST_REQUEST:
        'RA_SUITABILITY_TEST_SIGN_TEST_REQUEST',
    RA_SUITABILITY_TEST_STATUS_FAILURE: 'RA_SUITABILITY_TEST_STATUS_FAILURE',
    RA_SUITABILITY_TEST_STATUS_REQUEST: 'RA_SUITABILITY_TEST_STATUS_REQUEST',
    RA_SUITABILITY_TEST_STATUS_SUCCESS: 'RA_SUITABILITY_TEST_STATUS_SUCCESS',
    RA_SUITABILITY_TEST_RETRY_TEST_ENABLED:
        'RA_SUITABILITY_TEST_RETRY_TEST_ENABLED',
    RA_SUITABILITY_TEST_UPDATE_BACKUP: 'RA_SUITABILITY_TEST_UPDATE_BACKUP',
    RA_SUITABILITY_TEST_UPDATE_CAPITAL: 'RA_SUITABILITY_TEST_UPDATE_CAPITAL',
    RA_SUITABILITY_TEST_UPDATE_FINANCIAL:
        'RA_SUITABILITY_TEST_UPDATE_FINANCIAL',
    RA_SUITABILITY_TEST_UPDATE_INCOMING_VALUE:
        'RA_SUITABILITY_TEST_UPDATE_INCOMING_VALUE',
    RA_SUITABILITY_TEST_UPDATE_INVESTMENT_HORIZON_SLIDER:
        'RA_SUITABILITY_TEST_UPDATE_INVESTMENT_HORIZON_SLIDER',
    RA_SUITABILITY_TEST_UPDATE_KNOWLEDGE:
        'RA_SUITABILITY_TEST_UPDATE_KNOWLEDGE',
    RA_SUITABILITY_TEST_UPDATE_OBJECTIVE:
        'RA_SUITABILITY_TEST_UPDATE_OBJECTIVE',
    RA_SUITABILITY_TEST_UPDATE_OUTGOING_VALUE:
        'RA_SUITABILITY_TEST_UPDATE_OUTGOING_VALUE',
    RA_SUITABILITY_TEST_UPDATE_TEMPORAL_HORIZON:
        'RA_SUITABILITY_TEST_UPDATE_TEMPORAL_HORIZON',
    RA_SUITABILITY_TEST_UPDATE_TOOLS: 'RA_SUITABILITY_TEST_UPDATE_TOOLS',
    RA_SUITABILITY_TEST_UPDATE_MARKET_RISK:
        'RA_SUITABILITY_TEST_UPDATE_MARKET_RISK',
    RA_SUITABILITY_TEST_GET_PDF_TEST_SUCCESS:
        'RA_SUITABILITY_TEST_GET_PDF_TEST_SUCCESS',
    RA_SUITABILITY_TEST_UPDATE_VOLATILITY_INPUT_VALUE:
        'RA_SUITABILITY_TEST_UPDATE_VOLATILITY_INPUT_VALUE',
    RA_SUITABILITY_TEST_UPDATE_VOLATILITY_VALUE:
        'RA_SUITABILITY_TEST_UPDATE_VOLATILITY_VALUE',
    RA_SUITABILITY_TEST_BUTTON_RENEW_PRESSED:
        'RA_SUITABILITY_TEST_SET_BUTTON_REDO_PRESSED',
    RA_SUITABILITY_TEST_SET_SUSTAINABILITY_ANSWER:
        'RA_SUITABILITY_TEST_SET_SUSTAINABILITY_ANSWER',
    RA_SUITABILITY_TEST_SET_SUSTAINABILITY_INVESTMENT_FACTORS:
        'RA_SUITABILITY_TEST_SET_SUSTAINABILITY_INVESTMENT_FACTORS',
    RA_SUITABILITY_TEST_SET_SUSTAINABILITY_PIAS:
        'RA_SUITABILITY_TEST_SET_SUSTAINABILITY_PIAS',
    RA_SUITABILITY_TEST_SET_SUSTAINABILITY_TAXONOMIA:
        'RA_SUITABILITY_TEST_SET_SUSTAINABILITY_TAXONOMIA',
    RA_SUITABILITY_TEST_SET_SUSTAINABILITY_INVESTMENT_OBJECTIVE:
        'RA_SUITABILITY_TEST_SET_SUSTAINABILITY_INVESTMENT_OBJECTIVE',
    RA_SUITABILITY_TEST_SET_SUSTAINABILITY_OUR_STRATEGIES:
        'RA_SUITABILITY_TEST_SET_SUSTAINABILITY_OUR_STRATEGIES',
    RA_SUITABILITY_SET_SUSTAINABILITY_QUESTION_ID:
        'RA_SUITABILITY_SET_SUSTAINABILITY_QUESTION_ID',
    RA_TIME_HORIZON_CHECK_FAILURE: 'RA_TIME_HORIZON_CHECK_FAILURE',
    RA_TIME_HORIZON_CHECK_REQUEST: 'RA_TIME_HORIZON_CHECK_REQUEST',
    RA_TIME_HORIZON_CHECK_SET_TIME: 'RA_TIME_HORIZON_CHECK_SET_TIME',
    RA_TIME_HORIZON_CHECK_SUCCESS: 'RA_TIME_HORIZON_CHECK_SUCCESS',
    RA_TIME_HORIZON_CHECK_RESET_TIME_HORIZON_CHECK:
        'RA_TIME_HORIZON_CHECK_RESET_TIME_HORIZON_CHECK',
    RA_UPDATE_SELECTED_GOAL: 'RA_UPDATE_SELECTED_GOAL',
    RA_WIZARD_CHANGE_STEP_COMPLETED_VALUE:
        'RA_WIZARD_CHANGE_STEP_COMPLETED_VALUE',
    RA_WIZARD_CHANGE_STEP: 'RA_WIZARD_CHANGE_STEP',
    RA_WIZARD_INITIALIZE: 'RA_WIZARD_INITIALIZE',
    RA_WIZARD_MARK_COMPLETED_AND_CHANGE_STEP:
        'RA_WIZARD_MARK_COMPLETED_AND_CHANGE_STEP',
    RA_WIZARD_RESET: 'RA_WIZARD_RESET',
    RA_WIZARD_SET_TOTAL_ANSWERS: 'RA_WIZARD_SET_TOTAL_ANSWERS',
    RA_WIZARD_SHOULD_DISPLAY_MODAL: 'RA_WIZARD_SHOULD_DISPLAY_MODAL',
    RA_WIZARD_SHOW_MODAL: 'RA_WIZARD_SHOW_MODAL',
    RA_WIZARD_SHOW_FIRST_ANSWER_MODAL: 'RA_WIZARD_SHOW_FIRST_ANSWER_MODAL',
    RA_WIZARD_STEP_UPDATED: 'RA_WIZARD_STEP_UPDATED',
    RA_WIZARD_TOGGLE_CATEGORY_EXPANDANDABILITY_VALUE:
        'RA_WIZARD_TOGGLE_CATEGORY_EXPANDANDABILITY_VALUE',
    RA_WIZARD_TOGGLE_CATEGORY_EXPANDED_VALUE:
        'RA_WIZARD_TOGGLE_CATEGORY_EXPANDED_VALUE',
};
